import Temperature from 'app/shared-components/Temperature'
import ModifiedValue from 'app/shared-components/ModifiedValue'
import Checkbox from 'app/shared-components/Checkbox'
import AmountOfTime from 'app/shared-components/AmountOfTime'
import {
    MultipleEnumComponentConfig, MultipleEnumComponents,
} from 'app/shared-components/EnumListMultipleColored'
import RemoveComment from 'app/shared-components/CommentsLog/RemoveComment'

import WorkingDaysLeftAlert from 'app/shared-components/WorkingDaysLeftAlert'
import WorkingDaysLeftAlertConfig from 'app/shared-components/WorkingDaysLeftAlert/WorkingDaysLeftAlert.types'
import OrderTableLink from 'app/common/DomainObject/ComponentMapper/OrderTableLink'
import FormErrorList from './FormErrorList'
import List from './List'
import Boolean from './Boolean'
import ChipCheckMark from './ChipCheckMark'
import LoggerAge, {
    LoggerAgeFromDate,
} from './LoggerAge'
import StatusAge from './StatusAge'
import Link from './Link'
import ContainerStatusEnriched from './ContainerStatusEnriched'
import AdditionalFeesStatusEnriched from './AdditionalFeesStatusEnriched'
import LaneFeesStatusEnriched from './LaneFeesStatusEnriched'
import TemperatureCelsius from './TemperatureCelsius'
import TemperatureAge from './TemperatureAge'
import ContainerTempRange from './ContainerTempRange'
import ContainerTemp from './ContainerTemp'
import LaneStatus from './LaneStatus'
import LaneDateEnriched from './LaneDateEnriched'
import ContainerSelectionUntil from './ContainerSelectionUntil'
import Age from './TemperatureAge/Age'
import ContainerForPooling from './ContainerForPooling'
import StepProgress from './StepProgress'
import NotificationType from './NotificationType'
import LastSentOn from './LastSentOn'
import Recipients from './Recipients'
import SendTimeCell from './SendTimeCell'
import CloudIconBoolean from './CloudIconBoolean'
import TransportMode from './TransportMode'
import {
    LabelsComponentConfig, LabelsComponents,
} from './ModifiedField'
import {
    EnumComponentConfig, EnumComponents,
} from './EnumComponents.config.types'
import PoolingRequestedDelivery from './PoolingRequestedDelivery'
import PoolingEstimatedPickup from './PoolingEstimatedPickup'
import EstimatedDeliveryDeparture from './EstimatedDeliveryDeparture'
import DownloadDocument from './DownloadDocument'
import QuotePdfDelete from './QuotePdfDelete'
import QuotePdfDescriptionEdit from './QuotePdfDescriptionEdit'
import LoggerDocumentDelete from './LoggerDocumentDelete'
import TableMultipleValues, {
    MultipleValuesComponentsConfig,
} from './TableMultipleValues'
import SkyNetTableLink, {
    SkyNetTableLinkConfig,
} from './SkyNetTableLink'
import DateTimeCell from './DateTimeCell'
import LoggerLastActivated from './LoggerLastActivated'
import ContainerStatus from './ContainerStatus'

/* This object should contain all component without
special props requirements in config that we will use as componentName in:
 SkyNetTable(now) and RichTableReduxWrapper */
export const SpecialPropsLessComponents = {
    ModifiedValue,
    List,
    Temperature,
    Boolean,
    ChipCheckMark,
    LoggerAge,
    LoggerAgeFromDate,
    StatusAge,
    Link,
    Checkbox,
    ContainerStatusEnriched,
    ContainerStatus,
    AdditionalFeesStatusEnriched,
    LaneFeesStatusEnriched,
    TemperatureCelsius,
    LaneDateEnriched,
    LaneStatus,
    ContainerTemp,
    TemperatureAge,
    ContainerTempRange,
    ContainerSelectionUntil,
    Age,
    ContainerForPooling,
    StepProgress,
    NotificationType,
    LastSentOn,
    Recipients,
    SendTimeCell,
    CloudIconBoolean,
    TransportMode,
    PoolingRequestedDelivery,
    PoolingEstimatedPickup,
    EstimatedDeliveryDeparture,
    DownloadDocument,
    QuotePdfDelete,
    QuotePdfDescriptionEdit,
    LoggerDocumentDelete,
    RemoveComment,
    AmountOfTime,
    DateTimeCell,
    LoggerLastActivated,
    OrderTableLink,
    FormErrorList,
}

type SpecialPropsLessComponentConfig = {
    componentName?: keyof typeof SpecialPropsLessComponents,
}

export const ComponentTableCollection = {
    ...SpecialPropsLessComponents,
    ...EnumComponents,
    ...LabelsComponents,
    ...MultipleEnumComponents,
    WorkingDaysLeftAlert,
    SkyNetTableLink,
    TableMultipleValues,
}

/* Discriminated union for all possible configs for table cell components */
export type AllCellComponentsSpecialProps = SpecialPropsLessComponentConfig
    | EnumComponentConfig
    | LabelsComponentConfig
    | MultipleEnumComponentConfig
    | WorkingDaysLeftAlertConfig
    | SkyNetTableLinkConfig
    | MultipleValuesComponentsConfig

type OmitComponentName<TypeWithComponentNameProp> = Omit<TypeWithComponentNameProp, 'componentName'>

type SharedConfigProps = OmitComponentName<EnumComponentConfig>
    & OmitComponentName<LabelsComponentConfig>
    & OmitComponentName<MultipleEnumComponentConfig>
    & OmitComponentName<WorkingDaysLeftAlertConfig>
    & OmitComponentName<SkyNetTableLinkConfig>
    & OmitComponentName<MultipleValuesComponentsConfig>

/* It's properties from configuration that we want to share by redux */
export type SharedConfigPropNames = keyof SharedConfigProps
